import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react'

const AppContext = createContext({
  isOnline: true,
  hasError: false,
  isConfiguredScreen: true,
  isMercureWork: false,
  setHasError: (state) => state,
  setIsMercureWork: (state) => state,
  unconfiguredScreen: () => {},
  configuredScreen: () => {},
})

export const AppContextProvider = ({ children }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine)
  const [hasError, setHasError] = useState(false)
  const [isConfiguredScreen, setIsConfiguredScreen] = useState(true)
  const [isMercureWork, setIsMercureWork] = useState(false)

  const unconfiguredScreen = useCallback(() => {
    setIsConfiguredScreen(false)
    setHasError(true)
  }, [])

  const configuredScreen = useCallback(() => {
    setIsConfiguredScreen(true)
    setHasError(false)
  }, [])

  useEffect(() => {
    const handleOnline = () => setIsOnline(true)
    const handleOffline = () => setIsOnline(false)

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  return (
    <AppContext.Provider
      value={{
        isOnline,
        hasError,
        isConfiguredScreen,
        isMercureWork,
        setHasError,
        setIsMercureWork,
        configuredScreen,
        unconfiguredScreen,
      }}
    >
      {children}
    </AppContext.Provider>
  )
}

export const useAppContext = () => useContext(AppContext)
